import { Center, VStack, Box, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import NotFoundGraphic from '../../../../graphics/media-library/NotFoundGraphic'

const NotFoundView = ({minHeight}: {minHeight?: string}): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center height="100%" width="100%" minHeight={minHeight}>
      <VStack spacing={8}>
        <Icon
          as={NotFoundGraphic}
          width="260px"
          height="200px"
          color="appClearBlue"
        />
        <VStack spacing={2} width="100%">
          <Trans t={t} i18nKey="not_found">
            <Heading as="h4" fontSize="md" color="appBattleshipGrey">
              Not Found
            </Heading>
            <Heading
              as="h6"
              fontSize="sm"
              fontWeight="medium"
              color="appBattleshipGrey"
            >
              The requested asset does not exists
            </Heading>
          </Trans>
        </VStack>
      </VStack>
    </Center>
  )
}

export default NotFoundView
